













import { Component, Prop, Vue } from 'vue-property-decorator';

const COLOR_LIGHT = 'light';
const COLOR_DARK = 'dark';

const SIZE_SMALL = 'small';
const SIZE_MEDIUM = 'medium';
const SIZE_LARGE = 'large';

const TYPE_SPINNER = 'spinner';
const TYPE_DOTS = 'dots';

@Component
export default class LoadingAnimation extends Vue {
  @Prop({ type: String, default: TYPE_SPINNER }) private readonly type!: string;
  @Prop({ type: String, default: COLOR_DARK }) private readonly color!: string;
  @Prop({ type: String, default: SIZE_MEDIUM }) private readonly size!: string;
}
